import {
  HeroSection,
  StatsSection,
  RoadmapSection,
  CoursesSection,
  ServicesSection,
  RoleMapSection,
  SalarySection,
  HowItWorksSection,
  CertificationSection,
  FreeResourcesSection,
  FaqSection,
  EnrollSection,
} from "../components/training";

const Training = () => {
  return (
    <div className="bg-black text-white min-h-screen">
      <HeroSection />
      <StatsSection />
      <ServicesSection />
      <RoadmapSection />
      <CoursesSection />
      <RoleMapSection />
      <SalarySection />
      <HowItWorksSection />
      <CertificationSection />
      <FreeResourcesSection />
      <FaqSection />
      <EnrollSection />
    </div>
  );
};

export default Training;
